export default "__VITE_ASSET__BFA6NO4p__"